import { render, staticRenderFns } from "./push-edit.vue?vue&type=template&id=4c0ad66b&scoped=true&"
import script from "./push-edit.vue?vue&type=script&lang=js&"
export * from "./push-edit.vue?vue&type=script&lang=js&"
import style0 from "./push-edit.vue?vue&type=style&index=0&id=4c0ad66b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0ad66b",
  null
  
)

export default component.exports